module.exports = __webpack_public_path__ + "static/apple-icon-180x180-7172920de0bee20842ca1280660cdc2e.png";